// extracted by mini-css-extract-plugin
export default {"formBox":"Additem_formBox__GhVRC"};